import { Exclude } from 'class-transformer';
import {
  IsBoolean,
  IsDefined,
  IsInt,
  IsISO8601,
  IsNumber,
  IsOptional,
  IsString,
  Length,
  Matches
} from 'class-validator';
import { BaseDto } from '../base.dto';
import { UserBriefDto } from '../user-brief.dto';
import { MerchantDto } from '../merchant.dto';
import { EmployeeDto } from '../employee.dto';
import { validationPatterns } from '../../constants';

export class BankingDepositDto extends BaseDto {
  @IsDefined()
  @IsInt()
  merchantId: number;

  @IsDefined()
  @IsInt()
  depositUserId: number;

  @IsOptional()
  @IsInt()
  depositEmployeeId?: number;

  @IsOptional()
  @IsInt()
  redeemedByEmployeeId: number;

  @IsDefined()
  @IsISO8601()
  @Matches(/^\d{4}-\d{2}-\d{2}$/)
  collectedDay: string;

  @IsDefined()
  @IsISO8601()
  @Matches(/^\d{4}-\d{2}-\d{2}$/)
  redemptionDate: string;

  @IsOptional()
  @IsISO8601()
  redeemedDate: Date;

  @IsOptional()
  @IsBoolean()
  isRedeemed: boolean;

  @IsOptional()
  @IsBoolean()
  isHeadOffice: boolean;

  @IsDefined()
  @IsNumber({maxDecimalPlaces: 2})
  amount: number;

  @IsOptional()
  @IsString()
  @Length(0, 100)
  @Matches(validationPatterns.nameValidation)
  customerName: string;

  @IsOptional()
  @IsString()
  @Length(0, 20)
  @Matches(validationPatterns.digits)
  customerPhone: string;

  @IsDefined()
  @IsString()
  @Length(0, 254)
  @Matches(validationPatterns.email)
  customerEmail: string;

  @IsDefined()
  @IsString()
  @Length(0, 255)
  @Matches(validationPatterns.noteValidation)
  description: string;

  @IsOptional()
  @Exclude()
  depositUser: UserBriefDto;

  @IsOptional()
  @Exclude()
  redeemedByEmployee: EmployeeDto;

  @IsOptional()
  @Exclude()
  depositEmployee: EmployeeDto;

  @IsOptional()
  @Exclude()
  merchant: MerchantDto;

  @IsOptional()
  @IsInt()
  invoiceId: number;
  
  @IsOptional()
  @IsInt()
  status: number;

  @IsOptional()
  @IsString()
  publicURL?: string;
}
